import {
  FeatureKey,
  ROUTESWEB,
  resolveBridgeCourseReviewTarget,
} from "@repo/utils";
import { buildBridgeCourseSubscriptionsPath } from "../../../pages/dashboard/bridgeCourseDeeplink";
import { useAuthStore } from "../../../store/useAuthStore";
import { useFeatureStore } from "../../../store/useFeatureStore";
import { waitForFeatureStoreInit } from "../waitForFeatureStoreInit";
import type { DeeplinkRoute } from "../types";

const WEB_DEEPLINK_URL_STORAGE_KEY = "web_deeplink_url";

function clearStoredWebDeeplinkUrl(): void {
  try {
    localStorage.removeItem(WEB_DEEPLINK_URL_STORAGE_KEY);
  } catch {
    // ignore storage failures
  }
}

/** `type=bridgecourse` — resolve package from Firebase mapping, then open review or clear deeplink. */
export async function resolveBridgeCourseSubscriptionsDeeplinkRoute(): Promise<DeeplinkRoute> {
  console.log("[BridgeCourseDeeplink][Web] handling type=bridgecourse");

  const remoteConfigReady = await waitForFeatureStoreInit();
  console.log("[BridgeCourseDeeplink][Web] remote config wait", {
    remoteConfigReady,
  });

  const { enrolledPrograms } = useAuthStore.getState();
  const { flags, isInitialized } = useFeatureStore.getState();
  const mappingRaw = flags[FeatureKey.BRIDGE_COURSE_GRADE_MAPPING];

  console.log("[BridgeCourseDeeplink][Web] remote config state", {
    isInitialized,
    mappingKey: FeatureKey.BRIDGE_COURSE_GRADE_MAPPING,
    hasMapping: mappingRaw != null && mappingRaw !== "",
  });

  const target = resolveBridgeCourseReviewTarget(
    mappingRaw,
    enrolledPrograms,
  );

  if (!target) {
    console.warn(
      "[BridgeCourseDeeplink][Web] no target — clearing deeplink, navigating to dashboard",
    );
    clearStoredWebDeeplinkUrl();
    return { path: `/${ROUTESWEB.APP.DASHBOARD}` };
  }

  const path = buildBridgeCourseSubscriptionsPath(
    target.grade,
    target.packageId,
    target.examId,
  );

  console.log("[BridgeCourseDeeplink][Web] navigating to review", { path });

  return { path };
}
